import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-651b24c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("input", {
    type: "number",
    min: "0",
    max: "15",
    value: _ctx.modelValue,
    onKeypress: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.preventNonNumValues && _ctx.preventNonNumValues(...args))),
    onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', parseInt($event.target.value)))),
    class: _normalizeClass({ usedMark: _ctx.courseUsed, error: !_ctx.valid })
  }, null, 42, _hoisted_1))
}